import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bot, Loader2 } from "lucide-react";
import { isManager, isManagement, MANAGERS, MANAGEMENT, heeftRol } from "@/lib/rollen";

const MANAGER_ROLLEN = MANAGEMENT;

export const AiBudgetBanner = () => {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const laden = async () => { try { const { data } = await api.get("/ai-budget/status"); setSt(data); } catch { /* stil */ } };
  useEffect(() => { laden(); const t = setInterval(laden, 120000); return () => clearInterval(t); }, []);
  if (!st?.bereikt) return null;
  const isMgr = heeftRol(user, MANAGER_ROLLEN);
  const hervat = st.hervat_na ? new Date(st.hervat_na).toLocaleString("nl-NL", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
  const hervatten = async () => {
    setBusy(true);
    try { await api.post("/ai-budget/hervat"); toast.success("AI-functies hervat — volgende AI-aanroep probeert het opnieuw"); await laden(); }
    catch (e) { toast.error(e.response?.data?.detail || "Hervatten mislukt"); }
    setBusy(false);
  };
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-md p-3 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="ai-budget-banner">
      <div className="h-9 w-9 rounded-md bg-amber-500 text-white flex items-center justify-center shrink-0"><Bot className="h-5 w-5" /></div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-amber-800">AI-dagbudget bereikt</div>
        <div className="text-sm text-amber-900">AI-functies (mailanalyse, klachtbeoordeling, AI-agent, scans) pauzeren automatisch en hervatten rond <b>{hervat}</b>. Saldo verhogen: Emergent → Profile → Manage plan → Universal Key → Add Balance.</div>
      </div>
      {isMgr && (
        <Button size="sm" variant="outline" onClick={hervatten} disabled={busy} className="border-amber-400 text-amber-900 hover:bg-amber-100" data-testid="ai-budget-hervat-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "AI hervatten"}
        </Button>
      )}
    </div>
  );
};

export default AiBudgetBanner;
